















































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalTransmissionEdit/types";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: { NumberInput }
})
export default class OtherMedical2 extends Vue {
  @Prop() tab!: MedicalSpecification;
}
